import Settings from '../Settings.json';

export interface FeatureFlags {
    ipdModule: boolean;
}

type Environment = keyof typeof Settings;

const env = (process.env.NODE_ENV || 'development') as Environment;
const envSettings = Settings[env] ?? Settings.development;

export const featureFlags: FeatureFlags = {
    ipdModule: envSettings.featureFlags?.ipdModule ?? false,
};

export const isFeatureEnabled = (flag: keyof FeatureFlags): boolean =>
    featureFlags[flag];

export const IPD_ROUTE_PATHS = ['/ipd-admission', '/facility-configuration'] as const;
